<mat-expansion-panel [togglePosition]="expansionTogglePosition"
    class="nova__expansion nova__expansion--margin">
    <mat-expansion-panel-header class="nova__expansion__header">
        <mat-panel-title>
            Invoicing
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <div class="expansion-panel-body" *ngIf="(billingInvoicing$ | async)">
            <form >
                <div class="flex-row">
                    <div class="flex-width-80">
                        <div class="side-label-row flex-row">
                            <div class="nova__label flex-width-40">Payment Terms</div>
                            <div class="flex-width-60">
                                {{billingInvoicing.paymentTerms}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="side-label-row flex-row">
                    <div class="nova__label flex-width-40">Invoicing Notes</div>
                    <div class="flex-width-60">
                        <div *ngIf="!billingInvoicing.invoicingNotes; else invoicingNotesTemplate">
                            None
                        </div>
                        <ng-template #invoicingNotesTemplate>
                            <div [innerHTML]="billingInvoicing.invoicingNotes | sanitizer" class="inner-text"></div>
                        </ng-template>
                    </div>
                </div>
                <div class="side-label-row flex-row">
                    <div class="nova__label flex-width-40">Enable Tax Collection for Invoicing</div>
                    <div class="flex-width-60">
                        {{billingInvoicing.enableTaxCollectionForInvoicing ? 'Yes' : 'No'}}
                    </div>
                </div>
                <div class="side-label-row flex-row">
                    <div class="nova__label flex-width-40">Invoices Require Review</div>
                    <div class="flex-width-60">
                        {{billingInvoicing.enableInvoiceReview ? 'Yes' : 'No'}}
                    </div>
                </div>
            </form>
        </div>
    </ng-template>
</mat-expansion-panel>